import React, { FC, HTMLAttributes, useMemo } from 'react';
import * as classes from './Link.module.scss';
import cn from 'classnames';
import { Link as GatsbyLink } from 'gatsby-plugin-react-i18next';

interface Props extends HTMLAttributes<HTMLElement> {
  path: string;
  isLinkInText?: boolean;
  activeClassName?: string;
  title?: string;
  isTargetBlank?: boolean;
  isExternalLink?: boolean;
}

const Link: FC<Props> = ({ path, isLinkInText, isTargetBlank, isExternalLink, title, children, activeClassName, ...rest }) => {
  const linkClassName = useMemo(() => {
    return cn(classes.element, rest.className, isLinkInText && classes.linkInText);
  }, [isLinkInText, rest.className]);

  return (
    <>
      {isExternalLink ? (
        <a href={path} title={title} target={isTargetBlank ? '_blank' : ''} rel='noreferrer'>
          <span {...rest} className={linkClassName}>
            {children}
          </span>
        </a>
      ) : (
        <GatsbyLink to={path} activeClassName={activeClassName} title={title}>
          <span {...rest} className={linkClassName}>
            {children}
          </span>
        </GatsbyLink>
      )}
    </>
  );
};

export default Link;
